import React, {FunctionComponent} from "react";
import ReactMarkdown from "react-markdown";

const styles = require("./sideContent.module.scss");


interface Props {
    brandImage: any;
    brandName: string;
    content: string;
    title: string;
}

export const SideContent: FunctionComponent<Props> = props => {
    const {brandImage, content, title} = props;
    return (
        <div className={styles.sideContainer}>
            <div className={styles.topContainer}>
                <div className={styles.brandImage}>
                    {brandImage.url && <img src={brandImage.url}/>}
                </div>
                <div className={styles.title}>
                    {title}
                </div>
            </div>
            <div className={styles.middleContainer}>
                <ReactMarkdown className={styles.content} source={content}/>
            </div>
        </div>
    );
};